
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.73 2.386L4.551 8.56a.26.26 0 01-.184.076H2.083A2.083 2.083 0 000 10.72v3.556a2.083 2.083 0 002.083 2.083h2.285a.26.26 0 01.184.077l6.177 6.173a1.042 1.042 0 001.771-.734V3.125a1.042 1.042 0 00-1.77-.739zm7.593 2.787a1.042 1.042 0 00-1.473 1.473 8.275 8.275 0 010 11.707 1.042 1.042 0 001.473 1.473 10.357 10.357 0 000-14.653z"}}),_c('path',{attrs:{"d":"M20.876 2.535a1.042 1.042 0 00-1.473 1.473 12.023 12.023 0 010 16.98 1.042 1.042 0 101.473 1.472 14.107 14.107 0 000-19.925zm-5.104 5.278a1.042 1.042 0 10-1.475 1.471 4.561 4.561 0 010 6.437 1.042 1.042 0 101.474 1.467 6.648 6.648 0 000-9.375z"}})])
          )
        }
      }
    